<div
  class="d-flex justify-content-between align-items-center px-2 mb-3"
  [formGroup]="form"
>
  <div
    class="btn-group btn-group-sm"
    role="group"
  >
    <input
      type="radio"
      class="btn-check"
      formControlName="range"
      [value]="2"
      id="2-months-ago"
      autocomplete="off"
    >
    <label
      [class.active]="form.controls.range.value == 2"
      class="btn btn-outline-primary"
      for="2-months-ago"
    >{{'label.2monthsAgo' | translate}}</label>

    <input
      type="radio"
      class="btn-check"
      formControlName="range"
      [value]="1"
      id="last-month"
      autocomplete="off"
    >
    <label
      [class.active]="form.controls.range.value == 1"
      class="btn btn-outline-primary"
      for="last-month"
    >{{'label.lastMonth' | translate}}</label>

    <input
      type="radio"
      class="btn-check"
      formControlName="range"
      [value]="0"
      id="current-month"
      autocomplete="off"
    >
    <label
      [class.active]="form.controls.range.value == 0"
      class="btn btn-outline-primary"
      for="current-month"
    >
      {{'label.currentMonth' |
      translate}}
    </label>

  </div>
  <div
    *ngIf="('manage-assets' | permission) && sim && currentAccount.getId() !== sim.ownerAccountId"
    class="row"
  >
    <div class="col-auto">
      <select
        class="form-select"
        formControlName="accountId"
      >
        <option [value]="currentAccount.getId()">{{'label.currentAccount' | translate}} ({{currentAccount.name}})
        </option>
        <option [value]="sim.ownerAccountId">{{'label.ownerAccount' | translate}} ({{sim.ownerAccountName}})</option>
      </select>
    </div>
  </div>
</div>
